import { render, staticRenderFns } from "./oilOrderList.vue?vue&type=template&id=cc89ad4c"
import script from "./oilOrderList.vue?vue&type=script&lang=js"
export * from "./oilOrderList.vue?vue&type=script&lang=js"
import style0 from "./oilOrderList.vue?vue&type=style&index=0&id=cc89ad4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports